<template>
  <div>
    <!-- 收单机构账号配置配置 -->
    <a-card title="收单机构账号配置" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>收单机构编号</span>
          <a-input v-model.trim="paramsData.acquirerOrgCode" placeholder="请输入收单机构编号" allow-clear/>
        </div>
        <div class="item">
          <span>收单机构名称</span>
          <a-input v-model.trim="paramsData.acquirerOrgName" placeholder="请输入收单机构名称" allow-clear/>
        </div>
        <div class="item">
          <span>来账户名</span>
          <a-input v-model.trim="paramsData.accountName" placeholder="请输入来账户名" allow-clear/>
        </div>
        <div class="item">
          <span>来账账号</span>
          <a-input v-model.trim="paramsData.accountNo" placeholder="请输入来账账号" allow-clear/>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="accountAddBtn">新增账号</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.id"
          >
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button
                    icon="delete"
                    style="color: #ff4d4f;"
                    type="link"
                    @click="deleteBtn(record)"
                >
                  删除
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"
                        :fn="getTableData"/>
      </div>
    </a-card>

    <!-- 新增账号弹窗 -->
    <a-modal
        v-model="accountAddShowVisible"
        title="新增收单机构来账账号"
        @ok="handleAddAccount"
        @cancel="accountAddShowVisible = false"
        :confirm-loading="confirmLoading"
    >
      <a-form-model
          ref="addForm"
          :model="addFormData"
          :rules="addRules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          :colon="false"
          label-align="left"
      >
        <a-form-model-item label="收单机构编号" prop="acquirerOrgCode">
          <a-input
              v-model.trim="addFormData.acquirerOrgCode"
              placeholder="请输入收单机构编号"
              allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="收单机构名称" prop="acquirerOrgName">
          <a-input
              v-model.trim="addFormData.acquirerOrgName"
              placeholder="请输入收单机构名称"
              allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="来账户名" prop="accountName">
          <a-input
              v-model.trim="addFormData.accountName"
              placeholder="请输入来账户名"
              allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="来账账号" prop="accountNo">
          <a-input
              v-model.trim="addFormData.accountNo"
              placeholder="请输入来账账号"
              allow-clear
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";

export default {
  name: 'acquirer',
  components: {LcfsPagination},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      // 新增弹窗
      accountAddShowVisible: false,
      confirmLoading: false,
      addFormData: {
        acquirerOrgCode: "",
        acquirerOrgName: "",
        accountName: "",
        accountNo: "",
      },
      addRules: {
        acquirerOrgCode: [
          {required: true, message: '请输入收单机构编号', trigger: 'blur'},
        ],
        acquirerOrgName: [
          {required: true, message: '请输入收单机构名称', trigger: 'blur'},
        ],
        accountName: [
          {required: true, message: '请输入来账户名', trigger: 'blur'},
        ],
        // accountNo: [
        //   { required: true, message: '请输入来账账号', trigger: 'blur' },
        // ],
      },

      // 表格数据
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "收单机构编号",
          dataIndex: "acquirerOrgCode",
          align: "center",
          width: 120,
          ellipsis: true,
        },
        {
          title: "收单机构名称",
          dataIndex: "acquirerOrgName",
          align: "center",
          width: 150,
          ellipsis: true,
        },
        {
          title: "来账户名",
          dataIndex: "accountName",
          align: "center",
          width: 120,
          ellipsis: true,
        },
        {
          title: "来账账号",
          dataIndex: "accountNo",
          align: "center",
          width: 150,
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],


      paramsData: {

        acquirerOrgCode: "",
        acquirerOrgName: "",
        accountName: "",
        accountNo: "",
      },
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    async getTableData() {
      try {
        const res = await this.api.acquirerAccountListApi({
          ...this.pagination,
          ...this.paramsData
        });
        if (res.code === 200) {
          this.tableData = res.data;
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    // 查询
    handleQuery() {
      this.paramsData.pageNo = 1;
      this.getTableData();
    },

    // 重置
    handleReset() {
      this.paramsData = {
        pageNo: 1,
        pageSize: 10,
        acquirerOrgCode: "",
        acquirerOrgName: "",
        accountName: "",
        accountNo: "",
      };
      this.getTableData();
    },

    // 新增账号
    accountAddBtn() {
      this.accountAddShowVisible = true;
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.resetFields();
      });
    },

    // 处理新增账号
    async handleAddAccount() {
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          this.confirmLoading = true;
          try {
            const res = await this.api.acquirerAccountSaveApi(this.addFormData);
            if (res.code === 200 && res.data) {
              message.success('新增成功');
              this.accountAddShowVisible = false;
              this.getTableData();
            } else {
              message.error(res.info || '新增失败');
            }
          } catch (error) {
            console.error("新增失败:", error);
            message.error('新增失败');
          } finally {
            this.confirmLoading = false;
          }
        } else {
          message.error('请填写完整信息');
        }
      });
    },

    // 删除账号
    deleteBtn(record) {
      this.$confirm({
        title: `确认删除收单机构 [${record.acquirerOrgName}] 的来账账号吗？`,
        content: '删除后无法恢复，请谨慎操作。',
        okText: '确认删除',
        cancelText: '取消',
        okType: 'danger',
        onOk: async () => {
          try {
            const res = await this.api.acquirerAccountDelApi(record.id);
            if (res.code === 200 && res.data) {
              message.success("删除成功");
              this.getTableData();
            } else {
              message.warning(res.info || "删除失败");
            }
          } catch (error) {
            console.error("删除失败:", error);
            message.error("删除失败");
          }
        },
        onCancel() {
          console.log("取消删除");
        },
      });
    },


  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-body {
  padding: 24px 34px;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}
</style>